import { gql } from '@apollo/client';

const resultFields = `
  status
  errorMessage
  maxCustom
  customCount
  results {
    id
    listId
    slot
    code
    isFixed
    label
    description
    price
    billingMode
    isActive
    adminDisabled
    icon
    sortOrder
  }
`;

export const getListingOptionsQuery = gql`
  query getListingOptions($listId: Int!) {
    getListingOptions(listId: $listId) {
      ${resultFields}
    }
  }
`;

export const saveListingOptionMutation = gql`
  mutation saveListingOption(
    $listId: Int!, $slot: String, $label: String, $description: String,
    $price: Float!, $billingMode: String, $icon: String, $isActive: Boolean
  ) {
    saveListingOption(
      listId: $listId, slot: $slot, label: $label, description: $description,
      price: $price, billingMode: $billingMode, icon: $icon, isActive: $isActive
    ) {
      ${resultFields}
    }
  }
`;

export const setListingOptionActiveMutation = gql`
  mutation setListingOptionActive($listId: Int!, $slot: String!, $isActive: Boolean!) {
    setListingOptionActive(listId: $listId, slot: $slot, isActive: $isActive) {
      ${resultFields}
    }
  }
`;

export const deleteListingOptionMutation = gql`
  mutation deleteListingOption($listId: Int!, $slot: String!) {
    deleteListingOption(listId: $listId, slot: $slot) {
      ${resultFields}
    }
  }
`;

export const adminSetListingOptionDisabledMutation = gql`
  mutation adminSetListingOptionDisabled($listId: Int!, $slot: String!, $disabled: Boolean!, $reason: String) {
    adminSetListingOptionDisabled(listId: $listId, slot: $slot, disabled: $disabled, reason: $reason) {
      ${resultFields}
    }
  }
`;

const settingsFields = `
  status
  errorMessage
  maxCustomOptions
  deliveryEnabled
  chauffeurEnabled
  maxCustomOptionsCeiling
`;

export const getBookingOptionSettingsQuery = gql`
  query getBookingOptionSettings {
    getBookingOptionSettings {
      ${settingsFields}
    }
  }
`;

export const updateBookingOptionSettingsMutation = gql`
  mutation updateBookingOptionSettings($maxCustomOptions: Int!, $deliveryEnabled: Boolean!, $chauffeurEnabled: Boolean!) {
    updateBookingOptionSettings(maxCustomOptions: $maxCustomOptions, deliveryEnabled: $deliveryEnabled, chauffeurEnabled: $chauffeurEnabled) {
      ${settingsFields}
    }
  }
`;
